import axios from "axios";

const BASE_URL = "https://utils.follow.whistle.mobi/pixel.php";

const sendPixelEvent = async (goalName) => {
    const clickId = window.localStorage.getItem("clickId");
    if(!clickId) {
        return;
    }
    try {
        const url = `${BASE_URL}?click_id=${encodeURIComponent(clickId)}&goal_name=${encodeURIComponent(goalName)}`;
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error tracking pixel event (${goalName}):`, error);
        throw error;
    }
};

export const pixelEvents = {
    kyc: () => sendPixelEvent("Lead"),
    approvedProcess: () => sendPixelEvent("Approval"),
    disbursed: () => sendPixelEvent("Disbursed"),
};
